let colors = require("../../assets/colors.json")

let Colorful = function() {
  this.colors = colors
}

export default Colorful;
